export const PAYMENT_CLAIM_STATUS_CREATED = 'CREATED'
export const PAYMENT_CLAIM_STATUS_PAYMENT_VERIFIED = 'PAYMENT_VERIFIED'
export const PAYMENT_CLAIM_STATUS_CANCELLED = 'CANCELLED'

export const paymentClaimStatusToHumanReadable = {
    [PAYMENT_CLAIM_STATUS_CREATED]: "created",
    [PAYMENT_CLAIM_STATUS_PAYMENT_VERIFIED]: "payment verified",
    [PAYMENT_CLAIM_STATUS_CANCELLED]: "cancelled"
}